import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import * as memberMessageSlice from "../../member-message.slice";
import Loader from "../../../../components/loader";
import { useEffect, useState } from "react";
import { getDefaultMemberMessageSearchCriteria } from "../../../../service/model/message.model";
import { selectLoggedInUser } from "../../../auth/auth.slice";
import StyledPagination from "../../../../components/table/styled-pagination";
import { configs } from "../../../../app/app-configs";
import MessageHistory from "./message-history";
import { UserType } from "../../../../shared/enums";

const MemberMessagesMemberView = () => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(memberMessageSlice.selectIsLoading);
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const memberMessages = useAppSelector(memberMessageSlice.selectMessages);
    const totalPages = useAppSelector(memberMessageSlice.selectTotalPages);
    const [page, setPage] = useState(1);
    const [memberId, setMemberId] = useState<number | undefined>(undefined);

    useEffect(() => {
        if (memberId) {
            dispatch(memberMessageSlice.fetchMemberMessagePage({ ...getDefaultMemberMessageSearchCriteria(), memberId: memberId, from: '' }));
        }
    }, [memberId]);

    useEffect(() => {
        if (loggedInUser && loggedInUser.type === UserType.MEMBER) {
            setMemberId(loggedInUser.roleData.member?.id);
        }
    }, [loggedInUser]);

    useEffect(() => {
        if (memberId) {
            dispatch(memberMessageSlice.fetchMemberMessagePage(
                {
                    ...getDefaultMemberMessageSearchCriteria(),
                    pagination: {
                        page: page - 1,
                        size: configs.PAGE_SIZE
                    },
                    memberId: memberId
                }
            ))
        }
    }, [page]);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {memberMessages &&
                <>
                    <MessageHistory messages={memberMessages ?? []} />
                    <StyledPagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={(page) => {
                            handlePageChange(page);
                        }}
                    />
                </>
            }
        </div>
    )
}

export default MemberMessagesMemberView;